/**
 * Autogenerated file.
 * For adding or changing icons, see README.MD
 */
import React from 'react';
import { createIcon } from '../../icon/create-icon';
// Outline
const ArchiveBoxOutline = props => (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  stroke: "var(--i-color)",
  strokeLinecap: props.strokeLinecap,
  strokeLinejoin: props.strokeLinejoin,
  strokeWidth: "var(--i-s-width)",
  d: "M3.75 6.75V19.5a.751.751 0 0 0 .75.75h15a.751.751 0 0 0 .75-.75V6.75m-16.5 0 1.5-3h13.5l1.5 3m-16.5 0h16.5M8.822 14.07 12 17.25m0 0 3.178-3.18M12 17.25v-7.5"
})));
// Fill
const ArchiveBoxFill = props => (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fill: "var(--i-color)",
  d: "m20.925 6.41-1.5-3a.853.853 0 0 0-.28-.3.783.783 0 0 0-.395-.11H5.25a.783.783 0 0 0-.395.11.853.853 0 0 0-.28.3l-1.5 3A.85.85 0 0 0 3 6.75V19.5c0 .4.158.78.439 1.06.282.28.663.44 1.061.44h15c.398 0 .779-.16 1.061-.44.281-.28.439-.66.439-1.06V6.75a.85.85 0 0 0-.075-.34zm-5.212 8.19-3.179 3.18c-.143.14-.335.22-.534.22s-.391-.08-.534-.22L8.288 14.6a.755.755 0 0 1 .025-1.04.805.805 0 0 1 .512-.22c.192 0 .379.07.522.2l1.903 1.9V9.75a.751.751 0 0 1 1.5 0v5.69l1.903-1.9c.143-.13.33-.2.522-.2.193.01.376.09.512.22.136.14.215.32.219.51.005.2-.064.38-.193.53zM4.959 6l.75-1.5h12.582l.75 1.5H4.959z"
})));
// DuoTone
const ArchiveBoxDuotone = props => (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fill: "var(--i-color)",
  d: "M20.25 6.75V19.5a.751.751 0 0 1-.75.75h-15a.751.751 0 0 1-.75-.75V6.75h16.5z",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  stroke: "var(--i-color)",
  strokeLinecap: props.strokeLinecap,
  strokeLinejoin: props.strokeLinejoin,
  strokeWidth: "var(--i-s-width)",
  d: "M3.75 6.75V19.5a.751.751 0 0 0 .75.75h15a.751.751 0 0 0 .75-.75V6.75m-16.5 0 1.5-3h13.5l1.5 3m-16.5 0h16.5M8.822 14.07 12 17.25m0 0 3.178-3.18M12 17.25v-7.5"
})));
/**
  Icon ArchiveBoxIcon in office group
*/
export const ArchiveBoxIcon = createIcon('ArchiveBoxIcon', 'archive-box', 'office', ArchiveBoxOutline, ArchiveBoxFill, ArchiveBoxDuotone, "0 0 24 24");